import {
  SALES_ORDER_ALL,
  SALES_ORDER_GET,
  SALES_ORDER_GET_BY_DELIVERY,
  SALES_ORDER_PUT,
  SALES_ORDER_DEL,
  SALES_ORDER_POST,
} from "../../actions/types";

const initialState = {
  sales_order: null,
  isLoading: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case SALES_ORDER_ALL:
      return {
        arr: [...action.payload],
        isLoading: true,
      };
    case SALES_ORDER_GET_BY_DELIVERY:
      return {
        arr: [...action.payload],
        isLoading: true,
      };
    case SALES_ORDER_GET:
      return {
        ...action.payload,
        isLoading: true,
      };
    case SALES_ORDER_POST:
      return action.payload;
    case SALES_ORDER_PUT:
      return action.payload;
    case SALES_ORDER_DEL:
      return { isLoading: true };
    default:
      return state;
  }
}
